import z from "zod";

const translationPath = "page.4uDlist.generationRule.servicePeriod.errors.";

export const servicePeriodSchema = z.object({
  id: z.string().optional(),
  startDate: z.date({ invalid_type_error: translationPath + "start_date" }),
  endDate: z.date({ invalid_type_error: translationPath + "end_date" }),
  serviceType: z
    .array(z.string(), {
      required_error: translationPath + "service_type",
    })
    .min(1, translationPath + "service_type"),
});

export type TServicePeriodForm = z.infer<typeof servicePeriodSchema>;
